export enum TelephonyWsEvents {
  GetCalls = 'get_calls'
}
